import { Component, Input } from "@angular/core";
import { VivaWalletPaymentService } from "src/app/core/services/vivawalet-payment.service";
import { OrderPreviewData } from "../../../../order-preview.component";
import { filter } from "rxjs";
import { NfcService } from "src/app/core/services/nfc.service";


@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class CardComponent {
    @Input({ required: true }) data!: OrderPreviewData;

    paymentInProgress = false;
    error: boolean = false;
    nfcSupported = true;
    nfcEnabled = true;
    disableRetry = false;

    constructor(
        private vivaSvc: VivaWalletPaymentService,
        private nfcService: NfcService
    ) {
        this.vivaSvc.saleResult$
            .subscribe(({ orderId, status }) => {
                if (this.data.order.id !== orderId) return;

                if (status === 'failed') {
                    this.error = true;
                    this.paymentInProgress = false;
                }

                if (status === 'success') {
                    // No error, keep spinner off and button disabled
                    this.paymentInProgress = false;
                    this.disableRetry = true; // Optional: disable future retries
                }
            });
    }

    async ngOnInit(): Promise<void> {
        const nfcStatus = await this.nfcService.getNfcStatus();
        this.nfcSupported = nfcStatus.supported;
        this.nfcEnabled = nfcStatus.enabled;
    }

    async startCardPayment(): Promise<void> {
        this.error = false;
        this.paymentInProgress = true;

        try {
            const amountCents = Number(this.data.order.order.totalPrice) * 100;
            const orderId = this.data.order.id;
            await this.vivaSvc.startPayment(amountCents, orderId);
        } catch (err) {
            console.error('Card payment failed', err);
            this.error = true;
            this.paymentInProgress = false;
        }
    }

}